import {pathOr, pipe} from "ramda";

/**
 * Retrieve the network response data object from a dispatched action
 * @type {Function}
 */
export const selectResponseDataFromAction = pipe(pathOr({}, ['payload', 'response', 'data']));